import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { captureTrackingParams } from "@/lib/tracking-params";

/**
 * Global click-delegation tracker.
 * Pushes `call_click` to GTM's dataLayer whenever any tel: link is tapped
 * anywhere on the site. The GTM container handles forwarding to GA4/Meta.
 */
export function AnalyticsTracker() {
  // Re-capture attribution on every navigation so campaign data collected on
  // the landing page survives however far the visitor browses before
  // submitting the quote form.
  const pathname = useRouterState({ select: (s) => s.location.href });
  useEffect(() => {
    captureTrackingParams();
  }, [pathname]);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const anchor = target.closest<HTMLAnchorElement>('a[href^="tel:"]');
      if (!anchor) return;
      const number = anchor.getAttribute("href")?.replace(/^tel:/i, "") ?? "";
      const w = window as unknown as {
        dataLayer?: Record<string, unknown>[];
      };
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push({
        event: "call_click",
        phone_number: number,
        link_text: anchor.textContent?.trim().slice(0, 80) ?? "",
        page_path: window.location.pathname,
      });
    }
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true } as EventListenerOptions);
  }, []);

  return null;
}